
import { PropType } from "vue";
import { Vue, Options } from "vue-class-component";

@Options({
  name: "ModalProses",
  props: {
    title: {
      default: "",
      type: String,
    },
    onClose: {
      default: Function as PropType<() => void>,
      type: Function,
    },
    showFooter: {
      default: true,
      type: Boolean,
    },
    width: {
      default: "w-8/12",
      type: String,
    },
    height: {
      default: "",
      type: String,
    },
    isCustomTitle: {
      default: false,
      type: Boolean,
    },
    showBorderTitle: {
      default: true,
      type: Boolean,
    },
    scrollable: {
      default: true,
      type: Boolean,
    },
    isRounded: {
      default: true,
      type: Boolean,
    },
    titlePadding: {
      default: "px-8 py-4",
      type: String,
    },
    contentPadding: {
      default: "px-8 py-4",
      type: String,
    },
    footerPadding: {
      default: "px-8 py-6",
      type: String,
    },
    contentBgColor: {
      default: "bg-white",
      type: String,
    },
    footerBgColor: {
      default: "bg-gray-lp-700",
      type: String,
    },
    marginHeader: {
      default: "mb-0",
      type: String,
    },
    marginFooter: {
      default: "mt-2",
      type: String,
    },
    boxShadow: {
      type: String,
      default: "0px -5px 5px -1px #e0e0e0",
    },
    showClosed: {
      type: Boolean,
      default: true,
    },
    minHeight: {
      default: "",
      type: String,
    },

  },
})
export default class extends Vue {}
